// src/plugins/builder/templates/_helpers.ts
// Shared codegen helpers used by every template's generate() function.
export function pretty(json) {
    return JSON.stringify(json, null, 2) + '\n';
}
/** Strip newlines and trim, used for inline-strings inside generated code. */
export function safeString(s) {
    return s.replace(/[\\"`]/g, '\\$&').replace(/\r?\n/g, ' ').trim();
}
/** Compose the header banner generated plugins start with. */
export function header(opts) {
    return `// ${opts.name}
// Generated by the ReviewRadar Plugin Builder.
// Template: ${opts.templateId}
// Instance: ${opts.instanceId}
// You can edit this file by hand if you know React + TypeScript — but the
// safer way is to open the plugin in the Builder and change its settings.
`;
}
export function manifestFor(opts) {
    const m = {
        id: opts.instanceId,
        name: opts.name,
        version: '1.0.0',
        author: 'You (via Plugin Builder)',
        description: opts.description,
        category: opts.category,
        icon: opts.icon,
        permissions: opts.permissions,
        entry: opts.entry,
        config: opts.config,
        defaultConfig: opts.defaultConfig,
        docs: 'README.md',
    };
    if (opts.hooks)
        m.hooks = opts.hooks;
    if (opts.entry !== 'hook') {
        m.ui = opts.ui ?? { route: `/app/plugins/${opts.instanceId}`, navLabel: opts.name.slice(0, 20) };
    }
    return m;
}
export function readme(opts) {
    const cfgLines = opts.configSummary.map(([k, v]) => `- **${k}**: ${v}`).join('\n');
    return `# ${opts.name}

${opts.description}

## Built from template

\`${opts.templateId}\` — see the template's source under
\`src/plugins/builder/templates/${opts.templateId}/\`.

## Your settings

${cfgLines || '- _(no settings)_'}

## Editing

The safest way to change this plugin is to open the **Plugin Builder** in the
admin panel, click **Edit**, and change settings there. The Builder will
re-generate this folder.

If you'd rather hand-edit the code: \`plugin.tsx\` is the page UI, \`hooks.ts\`
is the background behaviour, and \`manifest.json\` declares what the plugin
can do.
`;
}
/** Final assembly. Returns the full GeneratedFiles object. */
export function assemble(opts) {
    return {
        manifest: opts.manifest,
        manifestJson: pretty(opts.manifest),
        pluginTsx: opts.pluginTsx,
        hooksTs: opts.hooksTs,
        readmeMd: opts.readmeMd,
    };
}
